module.exports = __webpack_public_path__ + "img/Tab1.861f515e.png";